import React, { useState, useEffect, useCallback } from 'react'
import { Button, Col, Divider, Dropdown, Image, Row, Space, Table, Tooltip, Typography, Tag } from 'antd'
import { DeleteOutlined, EditOutlined, MoreOutlined, PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import { useAuthContext } from 'contexts/Auth'
import { useNavigate } from 'react-router-dom'
import axios from 'axios';
import ExpandedData from './ExpandedData'

const { Title, Text } = Typography

const All = () => {

  const { user, getApiConfig } = useAuthContext()
  const [documents, setDocuments] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [status] = useState("active")
  const navigate = useNavigate()

  const readDocuments = useCallback(async () => {
    setIsLoading(true)
    axios.get(`${window.api}/courses/all/${status}`, getApiConfig())
      .then((res) => {
        const { data, status } = res
        if (status === 200) {
          const array = data.courses.map(course => ({ ...course, key: course.id }))
          setDocuments(array)
        }
      })
      .catch(error => {
        console.error(error)
        window.toastify(error.response?.data?.message || "Something went wrong while getting the courses", "error")
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [getApiConfig, status])
  useEffect(() => { readDocuments() }, [readDocuments])

  const handleDelete = (row) => {
    axios.delete(`${window.api}/courses/delete/${row.id}`, getApiConfig())
      .then((res) => {
        const { data, status } = res
        if (status === 200) {
          window.toastify(data.message, "success")
          const filteredDocuments = documents.filter(item => item.id !== row.id)
          setDocuments(filteredDocuments)
        }
      })
      .catch(error => {
        console.error(error)
        window.toastify(error.response?.data?.message || "Something went wrong while deleting the course", "error")
      })
  }

  const columns = [
    {
      title: 'Image', align: "center",
      render: (item, row) => <Image src={row.imageURL} alt={row.fullName} className="rounded-circle" style={{ width: 48, height: 48 }} />,
    },
    { title: 'Title', dataIndex: 'title', align: "center", },
    { title: 'Slug', dataIndex: 'slug', align: "center", },
    {
      title: 'Languages', dataIndex: 'languages', align: "center",
      render: (_, row) => <Text className='text-capitalize'>{row.languages.join(', ')}</Text>,
    },
    {
      title: 'Learning Types', dataIndex: 'learningTypes', align: "center",
      render: (_, row) => <Text className='text-capitalize'>{row.learningTypes.join(', ')}</Text>,
    },
    { title: 'Fee', dataIndex: 'netFee', align: "center", },
    {
      title: 'Target Gender(s)', dataIndex: 'targetGenders', align: "center",
      render: (_, row) => <Text className='text-capitalize'>{row.targetGenders.join(', ')}</Text>,
    },
    {
      title: 'Admission Status', dataIndex: 'isAdmissionOpen', align: "center",
      render: (_, row) => <Tag color={window.getTagColor(row.isAdmissionOpen ? "open" : "closed")}>{row.isAdmissionOpen ? "Open" : "Closed"}</Tag>,
    },
    {
      title: 'Last Date of Admission', dataIndex: 'lastDateOfAdmission', align: "center",
      render: (_, row) => <Text className='text-capitalize'>{window.dateFormat(row.lastDateOfAdmission, "dddd DD-MMM-YYYY")}</Text>,
    },
    {
      title: 'Status', dataIndex: 'status', align: "center", className: 'text-capitalize',
      render: (_, row) => <Tag color={window.getTagColor(row.status)}>{row.status}</Tag>,
    },
    { title: 'Sort Order', dataIndex: 'sortOrder', align: "center", },
    {
      title: 'Action', align: "center",
      render: (_, row) => (
        <Dropdown
          menu={{
            items: [
              { label: "Edit", icon: <EditOutlined />, onClick: () => { navigate(`/dashboard/courses/${row.id}`) } },
              { label: "Delete", icon: <DeleteOutlined />, onClick: () => { handleDelete(row) } },
            ]
          }}
          trigger={['click']}
        >
          <MoreOutlined className='text-primary' />
        </Dropdown>
      ),
    },
  ]

  return (
    <>
      <Row className='mb-3'>
        <Col>
          <Title level={3} className="mb-0">Courses</Title>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <div className="card">
            <Row>
              <Col span={24} className="d-flex justify-content-end align-items-center">
                <Space size="small">
                  <Tooltip title="Refresh Courses"><Button icon={<ReloadOutlined />} onClick={readDocuments} /></Tooltip>
                  <Tooltip title="Add Course"><Button type='primary' icon={<PlusOutlined />} onClick={() => { navigate("/dashboard/courses/add") }} /></Tooltip>
                </Space>
              </Col>
            </Row>

            <Divider />

            <Table
              columns={columns.filter((item) => !item.allowedroles || user.roles?.find(role => item.allowedroles?.includes(role)))}
              dataSource={documents}
              loading={isLoading}
              scroll={{ x: true }}
              size="small"
              expandable={{ expandedRowRender: (row) => <ExpandedData data={row} /> }}
            />
          </div>
        </Col>
      </Row>
    </>
  )
}

export default All